module.exports = __webpack_public_path__ + "static/img/appdow_banner.e7ad3e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/appdow_banner.png
// module id = UUVV
// module chunks = 4